import { MessageCircle, User, Server, Table2, UserCog, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const chains = [
  { from: "WhatsApp", icon: MessageCircle, to: "Sistema" },
  { from: "Sistema", icon: Server, to: "Planilha" },
  { from: "Planilha", icon: Table2, to: "Gestor" },
  { from: "Gestor", icon: UserCog, to: "Cliente" },
];

export const Problem = () => {
  return (
    <section id="problem" className="relative py-28 md:py-40 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Overline>O problema real</Overline>
            <h2 className="font-display font-extrabold text-3xl md:text-5xl tracking-tight leading-[1.05] mt-6">
              Sua empresa tem tecnologia.
              <br />
              <span className="text-neutral-500">
                Mas quem move a informação ainda são pessoas.
              </span>
            </h2>
            <p className="text-neutral-400 text-lg leading-relaxed mt-8 max-w-[50ch]">
              A maioria das operações não trava por falta de ferramentas. Trava
              porque cada ferramenta vive isolada — e alguém precisa copiar,
              colar, avisar e repassar manualmente entre elas o dia inteiro.
            </p>
          </Reveal>
        </div>

        <div className="space-y-3">
          {chains.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div className="flex flex-col md:flex-row md:items-center gap-2.5 md:gap-4 rounded-sm border border-white/10 bg-[#0a0a0a] p-4 md:p-5">
                  <div className="flex items-center gap-2 w-full md:w-auto md:min-w-0 md:flex-1">
                    <Icon className="h-5 w-5 text-neutral-400 shrink-0" strokeWidth={1.4} />
                    <span className="font-mono text-xs md:text-sm text-neutral-300 break-words md:truncate">
                      {c.from}
                    </span>
                  </div>
                  <ArrowRight className="h-4 w-4 text-neutral-700 shrink-0 self-center rotate-90 md:rotate-0" />
                  {/* Human bottleneck */}
                  <div className="flex items-center gap-2 rounded-sm border border-amber-500/30 bg-amber-500/5 px-3 py-2 shrink-0 self-center md:self-auto">
                    <User className="h-4 w-4 text-amber-500 shrink-0" strokeWidth={1.6} />
                    <span className="font-mono text-[11px] md:text-xs text-amber-400/90 whitespace-nowrap">
                      funcionário
                    </span>
                  </div>
                  <ArrowRight className="h-4 w-4 text-neutral-700 shrink-0 self-center rotate-90 md:rotate-0" />
                  <div className="flex items-center gap-2 w-full md:w-auto md:min-w-0 md:flex-1 md:justify-end">
                    <span className="font-mono text-xs md:text-sm text-neutral-300 break-words md:truncate md:text-right">
                      {c.to}
                    </span>
                  </div>
                </div>
              </Reveal>
            );
          })}
          <Reveal delay={0.4}>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-amber-500/70 pt-4">
              ← cada etapa depende de uma pessoa transportando dados
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
